/**
 * Created by dujiaxing on 2021/1/11 10:35 上午
 * 零跑提交接口
 */
import axios from "axios";

export async function saveAppointmentInfo(data: any) {
  return axios({
    method: "post",
    url: "/activity/saveAppointmentInfo.json",
    data
  });
}
